import {
    put,
    call,
    takeEvery,
    all,
    takeLatest
} from 'redux-saga/effects'
import { globalLoaderText } from 'redux/CommonDashboard/actions';
import api from '../../client/utils/clientApiHelper'
import * as pendingOrderActions from './action';
import {
    GET_EXPENDITURE,
    SUBMIT_ORDER_APPROVAL_REQUEST,
    GET_ORDERS_STATUS,
    GET_FLEET_PROCESSING_GRID_DATA,
    CANCEL_ORDER_REQUEST,
    GET_PENDING_ORDERS_GRID_DATA,
    GET_GRID_ORDERS_COUNT,
    GET_MY_ORDERS_GRID_DATA,
    GET_ALL_PENDING_ORDERS_GRID_DATA,
} from './types'
import { IPayload } from 'Model/IPayload';
import { API_URL, apiMethod, apiType } from 'utils';

function* getExpenditureHandler(): any {
    try {
        const response: any = [
            {
                Type: 'Planned',
                Budget: '$0.00',
                Spent: '$0.00',
                OpenPo: '$0.00',
                ApprovedRequest: '$0.00',
                ThisOrder: '1,020.00',
                OverUnder: '1,020.00'
            },
            {
                Type: 'Unplanned',
                Budget: '$0.00',
                Spent: '$0.00',
                OpenPo: '$0.00',
                ApprovedRequest: '$0.00',
                ThisOrder: '1,020.00',
                OverUnder: '1,020.00'
            },
            {
                Type: 'Growth',
                Budget: '$0.00',
                Spent: '$0.00',
                OpenPo: '$0.00',
                ApprovedRequest: '$0.00',
                ThisOrder: '1,020.00',
                OverUnder: '1,020.00'
            }
        ]
        yield put(pendingOrderActions.setExpenditure(response))
    } catch (error) {
        yield put(pendingOrderActions.setExpenditure([]))
    }
}

function* submitOrderApprovalRequestSaga(req: any): any {

    let payloadData : IPayload= {                
        apiMethod : apiMethod.POST,
        apiType : apiType.OrderManagement,
        endpoint : `orderapproval`,
        payload : req?.submitOrderRequest
    }
    try {
        yield put(globalLoaderText("Updating order...."));
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(pendingOrderActions.setIsOrderApprovalComplete(true))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(pendingOrderActions.setIsOrderApprovalComplete("false"))
        yield put(globalLoaderText(""));
    }
}

function* getGridOrdersCount(userId: any): any {
    yield put(pendingOrderActions.setIsGridCountsLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.GET,
            apiType : apiType.OrderManagement,
            endpoint : `orders/grid/home/count/${userId?.userId}`,
            payload : null
        }
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData);
        yield put(pendingOrderActions.setGridOrdersCount(response));
        yield put(pendingOrderActions.setIsGridCountsLoading(false))
    } catch (error) {
        yield put(pendingOrderActions.setGridOrdersCount([]))
        yield put(pendingOrderActions.setIsGridCountsLoading(false))
    }
}

function* getPendingOrdersGridData(request: any): any {
    yield put(pendingOrderActions.setIsGridDataLoading(true))
    let payloadData : IPayload= {                
        apiMethod : apiMethod.POST,
        apiType : apiType.OrderManagement,
        endpoint : `orders/grid/pendingorders/${request?.request?.userId}`,
        payload : request?.request?.payload
    }
    try {
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData );
        yield put(pendingOrderActions.setPendingOrdersGridData(response));
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    } catch (error) {
        yield put(pendingOrderActions.setPendingOrdersGridData([]));
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    }
    
}

function* getAllPendingOrdersGridData(request: any): any {
    yield put(pendingOrderActions.setIsGridDataLoading(true))
    let payloadData : IPayload = {
        apiType : apiType.OrderManagement,
        endpoint : `orders/grid/pendingorders/all/${request?.request?.userId}`,
        apiMethod : apiMethod.POST,
        payload : request?.request?.payload
    }
    try {
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData );
        yield put(pendingOrderActions.setAllPendingOrdersGridData(response));
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    } catch (error) {
        yield put(pendingOrderActions.setAllPendingOrdersGridData([]));
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    }
}

function* getMyOrdersGridData(request: any): any {
    yield put(pendingOrderActions.setIsGridDataLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.POST,
            apiType : apiType.OrderManagement,
            endpoint : `orders/grid/myorder/${request?.request?.userId}`,
            payload : request?.request?.payload
        }
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData);
        yield put(pendingOrderActions.setMyOrdersGridData(response));
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    } catch (error) {
        yield put(pendingOrderActions.setMyOrdersGridData([]))
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    }
}
function* getFleetProcessingGridData(request: any): any {
    yield put(pendingOrderActions.setIsGridDataLoading(true))
    try {
        let payloadData : IPayload= {                
            apiMethod : apiMethod.POST,
            apiType : apiType.OrderManagement,
            endpoint : 'orders/grid/fleetprocessing',
            payload : request?.request?.payload
        }
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData);
        yield put(pendingOrderActions.setFleetProcessingGridData(response))
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    } catch (error) {
        yield put(pendingOrderActions.setFleetProcessingGridData([]))
        yield put(pendingOrderActions.setIsGridDataLoading(false))
    }
}

function* getOrdersStatus(): any {
    let payloadData : IPayload= {
        apiType : apiType.OrderManagement,
        endpoint : `orders/orderstatuses`,
        apiMethod : apiMethod.GET,
        payload : null
    }
        
    try {
        const response = yield call(api.callOrderPost, API_URL.PostWebApp,payloadData);
        yield put(pendingOrderActions.setOrdersStatus(response));
    } catch (error) {
        yield put(pendingOrderActions.setOrdersStatus([]));
    }
}
function* cancelOrderRequestSaga(req: any): any {
    let payloadData : IPayload = {                
        apiMethod : apiMethod.POST,
        apiType : apiType.OrderManagement,
        endpoint : `orderapproval/cancel`,
        payload : req?.cancelOrderRequest
    }
    try {
        yield put(globalLoaderText("Cancel order...."));
        const response = yield call(api.callOrderPost, API_URL.PostWebApp, payloadData);
        if (response) {
            yield put(pendingOrderActions.setIsOrderCanceled(true))
        }
        yield put(globalLoaderText(""));
    } catch (error) {
        yield put(pendingOrderActions.setIsOrderCanceled(false))
        yield put(globalLoaderText(""));
    }
}

function* pendingOrderSagaWatcher() {
    yield takeEvery(GET_EXPENDITURE, getExpenditureHandler)
    yield takeEvery(SUBMIT_ORDER_APPROVAL_REQUEST, submitOrderApprovalRequestSaga)
    yield takeEvery(GET_GRID_ORDERS_COUNT, getGridOrdersCount)
    yield takeLatest(GET_PENDING_ORDERS_GRID_DATA, getPendingOrdersGridData)
    yield takeLatest(GET_MY_ORDERS_GRID_DATA, getMyOrdersGridData)
    yield takeEvery(GET_ORDERS_STATUS, getOrdersStatus)
    yield takeLatest(GET_FLEET_PROCESSING_GRID_DATA, getFleetProcessingGridData)
    yield takeEvery(CANCEL_ORDER_REQUEST, cancelOrderRequestSaga)
    yield takeLatest(GET_ALL_PENDING_ORDERS_GRID_DATA, getAllPendingOrdersGridData)
}

export default function* combinedSaga() {
    yield all([
        pendingOrderSagaWatcher()
    ])
}